import { globalStore } from "../../main.js";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import UserMethods from '../../shared/userMethods.js';
import Vue from 'vue';

export default {
    name: "resendWelcome",
    props: ['email', 'userType'],
	components: {
        PulseLoader
    },
    data() {
        return {
            showEmailSpinner: false
        } 
    },
    created: function() {
        var self = this;
        this.showEmailSpinner = true;
        UserMethods.sendWelcomeEmail(this, this.email, null, this.userType)
            .then(response => {
                self.showEmailSpinner = false;
                self.$router.push("/login");
            });
    },
    computed: {
        labels: function() {
            return globalStore.culture.strings.ResendWelcome;
        }
    }
};


// WEBPACK FOOTER //
// ./src/components/ResendWelcome/ResendWelcome.js